"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandPartnerMenuService = void 0;
class DemandPartnerMenuService {
    constructor() {
        this.modals = [];
    }
    add(modal) {
        return this.modals.push(modal);
    }
    remove(id) {
        this.modals = this.modals.filter(m => { return m.id != id; });
    }
    open(id, container, version, bidCPMAdjustments, events, pos) {
        for (let m in this.modals) {
            if (this.modals[m].id == id) {
                this.modals[m].container = container;
                this.modals[m].bidCPMAdjustments = bidCPMAdjustments;
                this.modals[m].events = events;
                this.modals[m].pos = pos;
                this.modals[m].open().then(res => {
                    this.modals[m].version = JSON.parse(JSON.stringify(version));
                });
                break;
            }
        }
    }
    close(id) {
        for (let m in this.modals) {
            if (this.modals[m].id == id) {
                this.modals[m].close();
                break;
            }
        }
    }
}
exports.DemandPartnerMenuService = DemandPartnerMenuService;
//# sourceMappingURL=demand-partner-menu.service.js.map